<template>
	<div>
		<bsh-datatable 
			:columns="columns"
            :buttons="buttons" 
			:link="$url+link"
            actionFild
            @update="update"
            @destroy="destroy"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
    props: ['link'],
	data(){
		return {
            columns: [
                {
                    label: '#',
                    field: 'id',
                    sort: 'asc'
                },
                {
                    label: 'Nome',
                    field: 'nome',
                    sort: 'asc'
                }
            ],
            buttons: [
                {
                    action: 'update',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-edit'
                },
                {
                    action: 'destroy',
                    classe: 'btn btn-danger',
                    iconClass: 'fas fa-trash'
                },
            ]
    	}
	},
    methods: {
        update(dado){
            this.$emit('update', dado.id);
        },
        destroy(dado){
            this.$emit('destroy', dado.id);
        },
    }
}
</script>